import { divIcon } from 'leaflet';
import type { LatLngExpression } from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import { Marker as C, useMap } from 'react-leaflet';
import { LoadingOverlay } from '@mantine/core';

type MarkerProps = {
  location: LatLngExpression;
  loading?: boolean;
};

const FlyToButton = ({ location }: MarkerProps) => {
  const map = useMap();
  if (location) {
    map.flyTo(location, 17, {
      animate: true,
      duration: 1.5,
      easeLinearity: 0.25,
    });
  }

  return null;
};

const iconMarkup = ReactDOMServer.renderToString(
  <div
    style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="tomato"
      stroke="white"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-map-pin-icon lucide-map-pin bounce-icon"
    >
      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
      <circle cx="12" cy="10" r="3" />
    </svg>
    <div
      style={{
        position: 'absolute',
        bottom: 0,
        width: '4px',
        height: '4px',
        borderRadius: '50%',
        backgroundColor: 'tomato',
        boxShadow: '0 0 8px 4px rgba(0, 0, 0, 0.4)',
      }}
    />
  </div>
);

const customIcon = divIcon({
  className: '',
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  html: iconMarkup,
});

const isValidLatLng = (coords?: LatLngExpression): coords is [number, number] =>
  Array.isArray(coords) &&
  coords.length === 2 &&
  coords.every((n) => typeof n === 'number' && n !== 0);

const Marker = ({ location, loading = false }: MarkerProps) => {
  if (loading) {
    return <LoadingOverlay visible={loading} />;
  }
  if (isValidLatLng(location)) {
    return (
      <>
        <FlyToButton location={location} />
        <C position={location} icon={customIcon} />
      </>
    );
  }
  return null;
};

export const MarkerDefault = ({ location }: MarkerProps) => (
  <C position={location} icon={customIcon} />
);

export default Marker;
